import { publicApi, protectedApi } from '../axios.config';
import { LoginCredentials, User } from '../../../types/auth.types';
import { api, apiClient } from '../axios.interceptor';
import { API_ENDPOINTS } from '../constants';

export const authApi = {
  // Public endpoints
  login: async (credentials: LoginCredentials) => {
    const response: any = await api.post<{
      user: any;
      tokens: any;
    }>(API_ENDPOINTS.AUTH.LOGIN, credentials);
    return response;
  },

  register: async (userData: {
    "name": string,
    "email": string,
    "password": string,
    "phone": string,
    "role": string,
  }) => {
    const response = await apiClient.post(API_ENDPOINTS.AUTH.REGISTER, userData);
    return response.data;
  },

  forgotPassword: async (email: string) => {
    const response = await apiClient.post('/auth/forgot-password', { email });
    return response.data;
  },

  resetPassword: async (token: string, newPassword: string) => {
    const response = await apiClient.post('/auth/reset-password', {
      token,
      newPassword,
    });
    return response.data;
  },

  verifyEmail: async (token: string) => {
    const response = await apiClient.post('/auth/verify-email', { token });
    return response.data;
  },

  verifyConsumerNumber: async (data: any) => {
    const response = await apiClient.post('/auth/verify-email', { ...data });
    return response.data;
  },


  getProfile: async () => {
    const response = await apiClient.get<User>('/auth/profile');
    return response.data;
  },

  updateProfile: async (data: Partial<User>) => {
    const response = await apiClient.put('/auth/profile', data);
    return response.data;
  },

  changePassword: async (currentPassword: string, newPassword: string) => {
    const response = await apiClient.post('/auth/change-password', {
      currentPassword,
      newPassword,
    });
    return response.data;
  },

  verifyOtp: async (postData: Partial<{
    phone: string,
    otp: string
  }>) => {
    const response = await apiClient.post(API_ENDPOINTS.AUTH.VERIFY_OTP, { ...postData });
    return response.data;
  },
};


export const refreshToken = async (): Promise<void> => {

  const refreshToken = localStorage.getItem('refreshToken');
  if (!refreshToken) {
    throw new Error('No refresh token available.');
  }

  const response = await api.post(API_ENDPOINTS.AUTH.REFRESH, { refreshToken });

  console.log({ response });

  const newAccessToken = response.data.accessToken;
  if (!newAccessToken) {
    throw new Error('Failed to get new access token from refresh endpoint.');
  }

  localStorage.setItem('accessToken', newAccessToken);
  api.defaults.headers.common['Authorization'] = `Bearer ${newAccessToken}`;
};

// This function clears session data and redirects.
export const logout = (): void => {
  localStorage.removeItem('accessToken');
  localStorage.removeItem('refreshToken');
  window.location.replace('/auth/login'); // Use .replace() to prevent going back
};